import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { AzureIntegrationView } from "../../gql";
import { USED_BY_COLUMN_ID } from "../constants";
import IntegrationsAzureUsedByTableDropdownCell from "./DropdownCell";
import IntegrationsAzureUsedByTableNameCell from "./NameCell";
import IntegrationsAzureUsedByTableSpaceCell from "./SpaceCell";
import IntegrationsAzureUsedByTableTypeCell from "./TypeCell";

export const INTEGRATIONS_AZURE_USED_BY_TABLE_CELLS: TableCellPerColumn<
  AzureIntegrationView["attachedStacks"][number]
> = {
  [USED_BY_COLUMN_ID.TYPE]: IntegrationsAzureUsedByTableTypeCell,
  [USED_BY_COLUMN_ID.NAME]: IntegrationsAzureUsedByTableNameCell,
  [USED_BY_COLUMN_ID.SPACE]: IntegrationsAzureUsedByTableSpaceCell,
  [USED_BY_COLUMN_ID.DROPDOWN]: IntegrationsAzureUsedByTableDropdownCell,
};
